import { CountryCode, InquiryIso6391LanguageCode } from 'lib/constants/locales';
import { FieldSchema } from 'lib/fields';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';
import { DocumentConfigDocumentsUpload } from 'lib/interfaces/documentConfig';
import { StepsConfig } from 'lib/interfaces/StepsConfig';

export interface TemplateAttributes {
  name: string;
  'name-display': string | null;
  'enabled-country-codes': CountryCode[];
  'enabled-locales': InquiryIso6391LanguageCode[];
  'intro-title': string | null;
  'intro-prompt': string | null;
  'intro-btn-submit': string | null;
  'select-country-title': string | null;
  'select-country-prompt': string | null;
  'success-title': string | null;
  'success-prompt': string | null;
  'success-btn-submit': string | null;
  'failed-title': string | null;
  'failed-prompt': string | null;
  'failed-btn-submit': string | null;
  'verify-government-id-select-title': string | null;
  'verify-government-id-select-prompt': string | null;
  'document-prompt-capture-button': string | null;
  'verify-ticket-routing': VerifyTicketRouting;
  'support-routed-emails': string[];
  'editable-tier': EditableTier;
  'allow-create-in-dashboard': boolean;
  'steps-config': StepsConfig;
  'documents-config'?: DocumentConfigDocumentsUpload;
  'custom-translations'?: CustomTranslation[];
  'v2-field-schemas': FieldSchema[];
  'updated-at': string;
}

export interface CustomTranslation {
  lang: string;
  'translation-url': string;
}

export enum VerifyTicketRouting {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum EditableTier {
  EngineeringOnly = 'engineering_only',
  Internal = 'internal',
  External = 'external',
}

export interface TemplateRelationships {
  'default-theme'?: ApiRelationship;
  organization?: ApiRelationship;
}

export type Template = ApiResource<TemplateAttributes, TemplateRelationships, ApiModel.Template>;

export type TemplateListPartial = ApiResource<
  Pick<TemplateAttributes, 'name' | 'updated-at'>,
  TemplateRelationships,
  ApiModel.Template
>;

export interface TemplateFilterOption {
  id: string;
  type: ApiModel.Template;
  name: string;
  'allow-create-in-dashboard': boolean;
  'default-theme-id': string;
  'updated-at'?: string;
}

export interface TemplateFiltersMeta {
  filters: TemplateFilterOption[];
}

export interface TemplateFiltersResponse {
  meta: TemplateFiltersMeta;
}
